import { useState } from 'react';

import { TaxIdInfo } from '@/Pages/Settings/utils/countryTaxIdInfo';
import { StripeCustomerBillingInfo } from '@/types/schema';

export const useBusinessInfoSubForm = (props: {
  defaults?: {
    dShow?: boolean;
    dAddressComplete?: boolean;
    dTaxIdInfo?: TaxIdInfo;
    dBusinessName?: string;
    dIsBusiness?: boolean;
    dTaxId?: string;
    dEmail?: string;
    dBillingInfo?: Partial<StripeCustomerBillingInfo> | null;
  };
  showBillingEmail?: boolean;
}) => {
  const {
    dAddressComplete = false,
    dTaxIdInfo,
    dBusinessName,
    dIsBusiness = false,
    dTaxId = '',
    dEmail = '',
    dBillingInfo = null,
  } = props.defaults || {};

  const [addressComplete, setAddressComplete] = useState(dAddressComplete);

  const [taxIdInfo, setTaxIdInfo] = useState<TaxIdInfo | undefined>(dTaxIdInfo);
  const [taxIdError, setTaxIdError] = useState<string | undefined>(undefined);
  const [businessName, setBusinessName] = useState<string | undefined>(
    dBusinessName
  );
  const [isBusiness, setIsBusiness] = useState<boolean>(dIsBusiness);

  const [billingInfo, setBillingInfo] =
    useState<Partial<StripeCustomerBillingInfo> | null>(dBillingInfo);
  const [taxId, setTaxId] = useState<string>(dTaxId);
  const [email, setEmail] = useState<string>(dEmail);
  const [emailError, setEmailError] = useState<string | undefined>(undefined);

  const reset = () => {
    setAddressComplete(dAddressComplete);
    setTaxIdInfo(dTaxIdInfo);
    setTaxIdError(undefined);
    setBusinessName(dBusinessName);
    setIsBusiness(dIsBusiness);
    setBillingInfo(dBillingInfo);
    setTaxId(dTaxId);
    if (props.showBillingEmail) setEmail(dEmail);
  };

  const handleEmailChange = (email: string) => {
    setEmailError(undefined);
    setEmail(email);
  };

  const hasAnyChanges =
    dTaxId !== taxId ||
    dEmail !== email ||
    dBusinessName !== businessName ||
    dIsBusiness !== isBusiness ||
    dBillingInfo?.name !== billingInfo?.name ||
    dBillingInfo?.address?.line1 !== billingInfo?.address?.line1 ||
    dBillingInfo?.address?.line2 !== billingInfo?.address?.line2 ||
    dBillingInfo?.address?.city !== billingInfo?.address?.city ||
    dBillingInfo?.address?.state !== billingInfo?.address?.state ||
    dBillingInfo?.address?.postal_code !== billingInfo?.address?.postal_code ||
    dBillingInfo?.address?.country !== billingInfo?.address?.country;

  return {
    addressComplete,
    setAddressComplete,
    taxIdInfo,
    setTaxIdInfo,
    taxIdError,
    setTaxIdError,
    businessName,
    setBusinessName,
    isBusiness,
    setIsBusiness,
    billingInfo,
    setBillingInfo,
    taxId,
    setTaxId,
    email,
    setEmail: handleEmailChange,
    reset,
    emailError,
    setEmailError,
    showBillingEmail: props.showBillingEmail,
    hasAnyChanges,
  };
};
